<template>
      <el-dialog title="审核" append-to-body :close-on-click-modal="false" :visible.sync="visible" width="400px">
      <el-form :model="detail" label-width="78px">
        <el-form-item label="审核人">
          <el-input v-model="detail.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="批准结果">
          <el-radio v-model="detail.isAudit" :label="false">打回</el-radio>
          <el-radio v-model="detail.isAudit" :label="true">通过</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="formOK">确 定</el-button>
      </div>
    </el-dialog>
</template>
<script>
export default{
  data(){
    return{
      visible:false,
      detail:{
        name:this.$cookie.get("name"),
        isAudit:true
      },
      personId:''
    }
  },
  methods:{
    formOK() {
      this.$http.post(this.$api.shiroApi.auditUser, {
        isAudit: this.detail.isAudit,
        id: this.personId
      }).then(({ data }) => {
        this.$message({
          message: data.msg,
          type: "success"
        });
        this.visible = false;
        this.$router.push({ name: 'accountMg' });
      });
    }
  }
}
</script>